/**
 * Whether a user has a feature flag active. Falls back to `user.features` when Auth holds a raw payload rather than a User model.
 *
 * @param {object|null|undefined} user
 * @param {string|null|undefined} featureClass
 * @returns {boolean}
 */
export function userHasFeature(user, featureClass) {
    if (!user || !featureClass) {
        return false;
    }

    if (typeof user.hasActiveFeature === 'function') {
        return Boolean(user.hasActiveFeature(featureClass));
    }

    return Boolean(user.features?.includes(featureClass));
}

export default userHasFeature;
